export default () => ({
  form__content: {
    marginBottom: '0.4rem',
  },
});
